import { useTranslation } from "react-i18next";
import { FigmaTypography } from "@libs/zapi-ui/custom";
import { TProjectOverview } from "@/zapi-frontend/stores/project";
import { SectionCard } from "./SectionCard";

export function KeyInsightsBlock({ overview }: { overview: TProjectOverview }) {
  const { t } = useTranslation("projectHome");
  if (!overview.keyInsights.length) return null;
  return (
    <SectionCard label={t("overview.keyInsights")} headerClassName="mb-3">
      <div className="flex flex-col gap-2">
        {overview.keyInsights.map((insight, i) => (
          <div
            key={i}
            className="flex flex-col gap-2 py-3 pl-5 border-l-2 border-[#122550] bg-gradient-to-r from-[#EBF0FC] to-transparent to-[77%]"
          >
            <span className="text-[14px] leading-[22px] font-medium tracking-[-0.14px] text-innoveraZinc-900">{insight.title}</span>
            <FigmaTypography component="span" variant="body-2" color="zinc700">{insight.body}</FigmaTypography>
          </div>
        ))}
      </div>
    </SectionCard>
  );
}
